export class ClosestAirportModel {
  public airportcode: string;
  public cityname: string;
  public statecode: string;
  public countrycode: string;

  constructor(
    airportcode: string,
    cityname: string,
    statecode: string,
    countrycode: string
  ) {
    this.airportcode = airportcode;
    this.cityname = cityname;
    this.statecode = statecode;
    this.countrycode = countrycode;
  }
}
